import { Divider } from "PFComponents/divider";
import { LoadingDots } from "PFComponents/loading_dots";
import { Typography } from "PFComponents/typography";
import { getProfileName } from "PFCore/helpers/profile";
import { _AuditPlannerExceptionsDictionary, BasicProfile, Engagement, ShortlistProfile } from "PFTypes";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import { getExceptionType } from "../../utils/helpers";
import { RoleInformationRow } from "./role_information_row";
import { WarningMessage } from "./warning_message";

type FillRoleContentProps = PropsWithChildren<{
  engagement: Engagement;
  profile: BasicProfile | ShortlistProfile;
  shouldShowSoftOverbooking: boolean;
  exception?: _AuditPlannerExceptionsDictionary;
  isFetching: boolean;
}>;

export const FillRoleContent = ({
  engagement,
  profile,
  shouldShowSoftOverbooking,
  exception,
  isFetching
}: FillRoleContentProps) => {
  const { t } = useTranslation("auditPlanner");
  const { t: tTranslation } = useTranslation();

  return (
    <>
      <RoleInformationRow
        data={[
          {
            label: tTranslation("engagement"),
            value: engagement.name
          },
          {
            label: t("modals.resource"),
            value: getProfileName(profile)
          }
        ]}
      />
      <Divider />
      <Typography variant="bodyRegular">
        {t("modals.creatingBookingForName", { name: getProfileName(profile) })}
      </Typography>
      {shouldShowSoftOverbooking && (
        <WarningMessage
          title={t("modals.overbookingDetected")}
          message={t("modals.thisWillAffectBookings", {
            name: getProfileName(profile)
          })}
          kind="overbooking"
        />
      )}
      {exception && (
        <WarningMessage
          title={t("modals.potentialExceptionDetected", {
            exceptionType: getExceptionType(exception)
          })}
          message={t("modals.allActionsRecordedInLog")}
          kind="error"
        />
      )}
      {isFetching && <LoadingDots />}
    </>
  );
};
